var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.8129 5.76021C24.5285 4.69042 23.6934 3.85084 22.6327 3.56646C20.7098 3.04736 13 3.04736 13 3.04736C13 3.04736 5.29032 3.04736 3.3674 3.56646C2.30664 3.85084 1.47157 4.69042 1.18719 5.76021C0.672607 7.69667 0.672607 11.7321 0.672607 11.7321C0.672607 11.7321 0.672607 15.7675 1.18719 17.704C1.47157 18.7738 2.30664 19.5772 3.3674 19.8616C5.29032 20.3807 13 20.3807 13 20.3807C13 20.3807 20.7098 20.3807 22.6327 19.8616C23.6934 19.5772 24.5285 18.7692 24.8129 17.704C25.3275 15.7675 25.3275 11.7321 25.3275 11.7321C25.3275 11.7321 25.3275 7.69667 24.8129 5.76021ZM10.4813 15.3974V8.06681L16.9226 11.7321L10.4813 15.3974Z",
    fill: "#0A66B0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame (3).785970e6771634ccaff7f57dcef207b4.svg";
export { ForwardRef as ReactComponent };